<template>
    <!-- <v-dialog v-model="dialog" max-width="700" min-height="550" persistent>  -->

    <v-card class="pa-3" style="border-radius: 20px;" :menu-props="{ zIndex: 100000 }">
        <v-card-title class="d-flex px-0 mx-4 justify-space-between align-center">
            <span class="text-h6">QC Details</span>
            <v-icon @click="close" class="cursor-pointer">mdi-close</v-icon>
        </v-card-title>

        <v-form @submit.prevent="save" ref="form">
            <v-row>
                <v-col cols="7" class="my-3 mx-4">
                    <span>Category : <b style="color: #204887;">{{
                        categoryData && categoryData.name ? categoryData.name : '' }}</b></span>
                </v-col>
                <v-col cols="2" class="mt-3">
                        <v-btn variant="outlined" elevation="0" class="px-3 "
                            style="border-color: #a19e9e !important; font-size: 12px;" @click="downloadTemplate">
                             <!-- <v-btn icon size="18" color="primary" class="mr-2"> -->
                                <v-icon color="primary" class="cursor-pointer mr-2">mdi-download</v-icon>
                            <!-- </v-btn> -->
                            Template
                        </v-btn>
                </v-col>
                <v-col cols="2" class="mt-3">
                        <v-btn variant="outlined" elevation="0" class="px-3"
                            style="border-color: #a19e9e !important; font-size: 12px;" @click="triggerFileUpload">
                            <v-icon color="primary" class="cursor-pointer mr-2">
                                mdi-upload
                            </v-icon>
                            Upload
                        </v-btn>
                </v-col>
                <!-- <v-col cols="4" class="d-flex ga-3 align-center"> -->
                     <!-- <v-btn variant="outlined" elevation="0" class="px-3 "
                        style="border-color: #a19e9e !important; font-size: 12px;" @click="downloadTemplate"> -->
                        <!-- <v-btn icon size="18" color="primary" class="mr-2">  -->
                            <!-- <v-icon color="primary" class="cursor-pointer mr-2">mdi-download</v-icon> -->
                        <!-- </v-btn>  -->
                        <!-- Template
                    </v-btn>-->
                     <!-- <v-btn variant="outlined" elevation="0" class="px-3"
                        style="border-color: #a19e9e !important; font-size: 12px;" @click="triggerFileUpload">
                        <v-icon color="primary" class="cursor-pointer mr-2">
                            mdi-upload
                        </v-icon>
                        Upload
                    </v-btn>  -->
                   <!-- <input ref="fileInput" type="file" style="display: none" @change="handleFileUpload"
                        accept=".csv,.xlsx,.xls"> -->

                <!-- </v-col> -->
                <!-- <v-col cols="5" class="py-0 pl-7 pr-0">
                    <div class="so">
                        <label for="label">Sale Order Type#</label>
                    </div>

                    <div class="d-flex flex-row"> 
                        <EnumAutoComplete :domain="'SALEORDERTYPE'" @changeEnumData="changeSaleOrderType($event)" :rules="getRules('Sale Order Type')" v-model="formData.sale_order_type" :placeholder="'Enter the Order Number'" />
                     </div> 
                </v-col> -->
                <!-- <v-col cols="6" class="py-0 pl-7 pr-0">
                    <div class="so">
                        <label for="label">Reference No#</label>
                    </div>  -->

                    <!-- <div class="d-flex ga-4 flex-row"> -->
                    <!-- <TextFieldComponent v-model="formData.so" :placeholder="'Enter the Order Number'" />
                </v-col> -->

                <!-- <v-col cols="4" class="d-flex ga-3 align-center"> -->
                        <!-- <v-btn variant="outlined" elevation="0" class="px-3"
                            style="border-color: #a19e9e !important; font-size: 12px;" @click="addChip">
                            <v-btn icon size="18" color="primary" class="rounded-circle mr-2">
                                <v-icon size="18">mdi-plus</v-icon>
                            </v-btn>
                            Add
                        </v-btn> -->

                        <!-- <v-btn variant="outlined" elevation="0" class="px-3 "
                            style="border-color: #a19e9e !important; font-size: 12px;" @click="downloadTemplate"> -->
                             <!-- <v-btn icon size="18" color="primary" class="mr-2"> -->
                                <!-- <v-icon color="primary" class="cursor-pointer mr-2">mdi-download</v-icon> -->
                            <!-- </v-btn> -->
                            <!-- Template
                        </v-btn> -->
                        <!-- 
                        <v-btn variant="outlined" elevation="0" class="px-3"
                            style="border-color: #a19e9e !important; font-size: 12px;" @click="triggerFileUpload">
                            <v-icon color="primary" class="cursor-pointer mr-2">
                                mdi-upload
                            </v-icon>
                            Upload
                        </v-btn> -->

                        <input ref="fileInput" type="file" style="display: none" @change="handleFileUpload"
                            accept=".csv,.xlsx,.xls">
                    <!-- </div> -->
                <!-- </v-col>  -->
                
                <v-col cols="12" class="py-0 pl-7 pr-0" v-if="showError">
                    <p style="color: red !important; font-size:small !important">{{ errorMsg }}</p>
                </v-col>
                <v-col cols="12" class="px-5">
                    <div class="chips mx-2">
                        <v-row class="ma-0">
                            <v-col cols="10" class="pr-0">
                                <v-text-field v-model="search" class="search-bar" label="Search"
                                    prepend-inner-icon="mdi-magnify" variant="outlined" density="compact"
                                    hide-details></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-btn variant="outlined" elevation="0"
                                    style="border-color: #a19e9e !important; font-size: 12px;" @click="deleteAll">
                                    Delete All
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-col cols="12" class="ch">
                            <v-chip v-for="chip in filteredChips" :key="chip.concat_value" closable class="ma-1"
                                @click:close="removeChip(chip)">
                                {{ chip.concat_value }}
                            </v-chip>
                        </v-col>
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="mx-4">Total Order Numbers : <b style="color: #204887;">{{ chips.length }}</b></div>
                </v-col>
            </v-row>
            <v-row justify="end" class="dialogBottom">
                <v-btn style=" --v-btn-height: 35px;" class="mr-2 cancel" @click="close()">Cancel</v-btn>
                <v-btn style=" --v-btn-height: 35px;" class="save" type="submit" :loading="loader">Save</v-btn>
            </v-row>
        </v-form>
    </v-card>
    <!-- </v-dialog>  -->
</template>

<script>
import * as XLSX from "xlsx";
import CategoryService from '@/api/service/Category/CategoryService';
import IssueService from '@/api/service/Issue/IssueService';
// import TextFieldComponent from '@/components/TextFieldComponent.vue';
// import AutoComplete from "@/components/ui/AutoComplete.vue";
// import EnumAutoComplete from "@/components/others/EnumAutoComplete.vue";
export default {
    props: ["issueId", "CategoryId", "issueData", "subCategoryData"],
    components: {
        // TextFieldComponent,
        // AutoComplete
        // EnumAutoComplete,
    },
    data() {
        return {
            showError: false,
            errorMsg: '',
            dialog: true,
            loader: false,
            formData: {
                qc: null,
                salesOrder: null,
                purchaseOrder: null,
                import: null,
                cust: null,
                ediBatch: null,
                so: null,
                sale_order_type:null,
                // orderNum:[]
            },
            categoryData: {},
            // orderNumInput: '', 
            chips: [],
            search: ''
        }
    },
    created() {
        console.log(this.subCategoryData,"subCategoryData^^^^")
        if (this.CategoryId) {
            this.getCategoryDetails(this.CategoryId)
        }
    },
    watch: {
        CategoryId(val) {
            if (val) this.getCategoryDetails(val);
        }
    },
    computed: {
        filteredChips() {
            if (!this.search) return this.chips;
            const term = this.search.toLowerCase();
            return this.chips.filter(chip => chip.concat_value.toLowerCase().includes(term));
        }
    },
    methods: {
        // changeSaleOrderType($event) {
        //     this.formData.sale_order_type = $event
        // },
        // getRules(name) {
        //     if (name && name.toLowerCase() === "email") {
        //         return [
        //             (v) => !!v || "E-mail is required.",
        //             (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
        //         ];
        //     }
        //     return [(v) => !!v || `${name} is required.`];
        // },
        confirm() {
            console.log(this.formData.orderNum, 'orderNum!!!!')
        },
        addChip() {
            if (this.formData.so.trim() !== '') {
                this.chips.push({concat_value: this.formData.so });
                this.formData.so = '';
                console.log(this.chips, "this.chips!!")
            }
        },
        async getCategoryDetails($id) {
            let $res = await CategoryService.findAll({ id: $id })
            console.log($res, "getCategoryDetails!!")
            this.categoryData = $res && $res.length > 0 ? $res[0] : {}
        },
        close() {
            this.$emit("closeDialog");
        },
        removeChip(chip) {
            const originalIndex = this.chips.findIndex(c => c.concat_value === chip.concat_value);
            if (originalIndex > -1) {
                this.chips.splice(originalIndex, 1);
            }
            console.log(this.chips, "delete!!")
        },

        deleteAll() {
            this.chips = []
        },
        async save() {
            this.loader = true
            console.log(this.chips, "chips!!")
            let $data = {
                order: this.chips,
                issueData: this.issueData,
                sub_category_code: this.subCategoryData.code ? this.subCategoryData.code : '',
                qc_required: this.issueData.qc_required ? this.issueData.qc_required : 0
            }
            await IssueService.multipleSubTask($data)
            this.$store.commit("SET_ISSUE_STATUS", 2);
            this.$emit("closeDialog");
            this.$emit("saveDialog");
            this.loader = false
        },
        downloadTemplate(){
            const headers = JSON.parse(this.subCategoryData.key_columns)
            const excelTemplate=[headers];
            console.log(excelTemplate,"excelTemplate!!")
                // excelTemplate = [...excelTemplate]
            const worksheet = XLSX.utils.aoa_to_sheet(excelTemplate);
    
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'template');
    
            XLSX.writeFile(workbook, `key_columns Template.xlsx`);
        },
        triggerFileUpload() {
            // Trigger the file input click event
            this.$refs.fileInput.click();
        },
        handleFileUpload(event) {
            this.errorMsg = ''
            console.log(this.subCategoryData, "t4t4");
            const file = event.target.files[0];
            this.processFile(file)
            // Handle the uploaded file (e.g., read its contents)
            console.log('File uploaded:', file);
        },
        processFile(file) {
            const allowed = [".xlsx", ".xls"];
            const name = file.name || "";
            const ext = name.slice(name.lastIndexOf(".")).toLowerCase();

            if (!allowed.includes(ext)) {
                return this.$emit("error", "Only .xlsx/.xls files allowed");
            }

            this.fileName = name;

            const reader = new FileReader();
            reader.onload = (ev) => {
                try {
                    const data = new Uint8Array(ev.target.result);
                    const workbook = XLSX.read(data, { type: "array" });
                    const sheetNames = workbook.SheetNames;
                    console.log(sheetNames.length, "Sheet names:", sheetNames);

                    if (sheetNames.length === 1) {
                        const worksheet = workbook.Sheets[sheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

                        console.log("Parsed JSON:", jsonData);
                        const key = JSON.parse(this.subCategoryData.key_columns);
                        console.log(key, "key11");
                        const headers = Object.keys(jsonData[0] || {});
                        console.log("Excel Headers:", headers);

                        const missingColumns = key.filter(column => !headers.includes(column));
                        if (missingColumns.length > 0) {
                            this.showError = true;
                            this.errorMsg = `Missing required columns: ${missingColumns.join(', ')}`;
                            return;
                        }
                        else{
                            this.showError = false;
                            const extractedObjects = jsonData.map(row => {
                                const obj = {};
                                key.forEach(column => {
                                    obj[column] = row[column];
                                });
                                const values = key.map(column => row[column]);
                                obj.concat_value = values.join('-');
                                // obj.sale_order_type = this.formData.sale_order_type;
                                console.log("pfpf",obj);
                                return obj;
                            });
                            const uniqueObjects = extractedObjects.filter((obj, index, self) => 
                                index === self.findIndex(o => o.concat_value === obj.concat_value)
                            );
                            this.chips = uniqueObjects;
                            console.log(this.chips,"pfpf3");
                            if (this.chips.length == 0) {
                                this.errorMsg = `In your uploaded Excel file,key columns are missing. Please contact your administrator to review the fields and re-upload it after verification.`
                                this.showError = true
                            }
                            // for (let i of headers) {
                            //     if (key.includes(i)) {
                            //         console.log(i, "loop");
                            //         // alert(`${i} column exist`)
                            //     }
                            //     else {
                            //         console.log(i, "loop1");
                            //         // this.errorMsg = `${i} column does not exist`
                            //         this.errorMsg = `In your uploaded Excel file,key columns are missing. Please contact your administrator to review the fields and re-upload it after verification.`
                            //         this.showError = true
                            //         console.log(this.errorMsg, "loop2", this.showError);
                            //         // alert(`${i} column does not exist`)
                            //     }
                            // }

                            console.log("Extracted Objects:", this.chips);
                            this.$emit("uploaded", jsonData);
                        }
                    } else {
                        const allSheets = {};
                        sheetNames.forEach((name) => {
                            const sheet = workbook.Sheets[name];
                            allSheets[name] = XLSX.utils.sheet_to_json(sheet, { defval: "" });
                        });
                        console.log("All sheets JSON:", allSheets);
                        this.$emit("uploaded", allSheets);
                    }
                } catch (err) {
                    console.error("Failed to parse Excel file", err);
                    this.$emit("error", err);
                }
            };
            reader.readAsArrayBuffer(file);
        }
    }
}
</script>

<style scoped>
::v-deep(.v-chip__close) {
    color: #204887 !important;
}

::v-deep(.v-chip){
    background-color: #5456581a;
    
}

.search-bar {
    height: 26px !important;
}

.chips {
    border: 1px solid #a19e9e;
    min-height: 200px;
    max-height: 200px;
    border-radius: 5px;

}

.ch {

    margin: auto;
    overflow-y: auto;
    min-height: 130px;
    max-height: 130px;
    overflow-x: hidden;
}

.so {
    display: flex;
    justify-content: space-between;
}

.add {
    display: flex;
    gap: 10px;
}

.v-selection-control .v-label {
    font-size: 26px !important;
    margin-left: 8px;
}
</style>